<div onfocus="" class="sidebar" [ngClass]="{ collapsed: isCollapsed }" (mouseover)="onMouseEnter(false)"
  (mouseleave)="onMouseEnter(false)">
  <div onfocus="" class="left-column">
    <!-- <div class="logo-container" *ngIf="!isCollapsed">
      <img src="../../../assets/img/NovaLogo.png" alt="hrnova" />
    </div>
    <div class="logo-container" *ngIf="isCollapsed" style="padding-left: 5px; width: 100%">
      <img src="../../../assets/img/hrLogoOnly.png" alt="hrnova" />
    </div> -->
    <div class="search-container" *ngIf="!isCollapsed">
      <div class="input-group input-group-sm">
        <span class="input-group-text bg-white border-end-0 border-dark-subtle shadow-none">
          <i class="fas fa-search text-muted"></i>
        </span>
        <input type="text" class="form-control border-start-0 border-dark-subtle border-end-0 shadow-none"
          placeholder="Search menu..." [(ngModel)]="searchTerm" (keyup)="filterMenus()">
        <span class="input-group-text bg-white border-start-0 border-dark-subtle shadow-none" *ngIf="searchTerm"
          (click)="clearSearch()" style="cursor: pointer;">
          <i class="fas fa-times text-muted"></i>
        </span>
      </div>
    </div>
    <ul class="nav flex-column">
      <li *ngFor="let item of filteredParentMenuList" class="nav-item">
        <a class="nav-link" (click)="toggleSubMenu(item)" [class.disabled-link]="isSidebarDisabled"
          [ngClass]="isMenuExpanded(item.id) ? 'active-link' : ''">
          <i [class]="item.icon"></i>
          <span *ngIf="!isCollapsed" class="menu-name">{{ item.name }}</span>
          <span *ngIf="!isCollapsed && item.link !== '/app/reports/all-reports'"><i class="fas transperantIcon"
              [ngClass]="isMenuExpanded(item.id) ? 'fa-caret-down' : 'fa-caret-right'"></i></span>
        </a>
        <ul *ngIf="isMenuExpanded(item.id) && item.link !== '/app/reports/all-reports'" class="submenu">
          <li *ngFor="let submenu of setSubMenus(item.id)" class="no-bullets">
            <a *ngIf="!isCollapsed" class="nav-link icons sub_menu_active" [routerLink]="submenu?.link"
              routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: false }"
              (click)="setMenuId(submenu.id)">
              {{ submenu?.name }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>